export default "__VITE_ASSET__DChbsa3J__"